// extracted by mini-css-extract-plugin
export default {"fileInput":"FileInput_fileInput__SyRp3","fake":"FileInput_fake__AFbL7"};